import { NewsEventNotice } from '../../../src_server/entity/generated/NewsEventNotice';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';export class EventAndNewsService extends GeneratedBizBase{
  async getEvents(): Promise<Response<NewsEventNotice[]>> {
    return super.restCall<Response<NewsEventNotice[]>>('get', '/v1/EventAndNewsService/getEvents', arguments);
  }
  async getNews(): Promise<Response<NewsEventNotice[]>> {
    return super.restCall<Response<NewsEventNotice[]>>('get', '/v1/EventAndNewsService/getNews', arguments);
  }
  async getAll(): Promise<Response<NewsEventNotice[]>> {
    return super.restCall<Response<NewsEventNotice[]>>('get', '/v1/EventAndNewsService/getAll', arguments);
  }
  async add(): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/EventAndNewsService/add', arguments);
  }
  async update(row: NewsEventNotice): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/EventAndNewsService/update', arguments);
  }
  async delete(id: number): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/EventAndNewsService/delete', arguments);
  }
}
